module.exports = import("https://esm.sh/@putout/bundle@5.5");;